import React from 'react'
import PropTypes from 'prop-types'
import { ButtonSmall, Tooltip } from 'react-wot-bootstrap'
import { connect } from 'react-redux'

import {
    SCHEDULE_HAS_CHANGES,
    SCHEDULE_TITLE,
    SCHEDULE_TOOLTIP,
} from 'containers/Schedule/shared_translations'
import { scheduleOpenThrottler } from 'helpers/schedule'
import { openSchedule } from 'state/actions/schedule'

import styles from './Title.scss'

export const Title = props => {
    const scheduleTooltipId = 'scheduleTooltip'
    const onScheduleButtonClick = () => scheduleOpenThrottler.throttle(props.openSchedule)

    return (
        <h1 className={styles.heading}>
            {props.children}
            <span className={styles.scheduleButton}>
                <ButtonSmall
                    type='mini'
                    onClick={onScheduleButtonClick}
                    tooltipId={scheduleTooltipId}
                >
                    <div className={styles.scheduleIcon} />
                </ButtonSmall>
                {props.showScheduleBubble && (
                    <div className={styles.scheduleButton__bubble}>{'!'}</div>
                )}

                <Tooltip id={scheduleTooltipId}>
                    <div className={styles.tooltipContent}>
                        <p className={styles.tooltipSubtitle}>{SCHEDULE_TITLE}</p>

                        {props.showScheduleBubble && (
                            <p className={styles.tooltipMessage}>{SCHEDULE_HAS_CHANGES}</p>
                        )}
                        <p className={styles.tooltipMessage}>{SCHEDULE_TOOLTIP}</p>
                    </div>
                </Tooltip>
            </span>
        </h1>
    )
}

Title.propTypes = {
    children: PropTypes.node.isRequired,
    openSchedule: PropTypes.func.isRequired,
    showScheduleBubble: PropTypes.bool.isRequired,
}

export const mapStateToProps = state => ({
    showScheduleBubble: !state.userFlags.schedule_visited,
})

export const mapDispatchToProps = {
    openSchedule,
}

export default connect(mapStateToProps, mapDispatchToProps)(Title)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/Title/Title.jsx